import React from 'react';
import { connect } from 'react-redux';
import {
  Button, Card, CardBody, CardTitle,
} from 'reactstrap';
import { actions, Form } from 'react-redux-form/immutable';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import qs from 'qs';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { LabeledText } from '../../../../../form/LabeledText';
import { LabeledSelect } from '../../../../../form/LabeledSelect';
import { marigramSearchModel, toSearchParameters } from './marigramSearchModel';
import {
  clearMarigramSearch as clearMarigramSearchAc,
  getCountries as getCountriesAc,
  getLocations as getLocationsAc,
  getRegions as getRegionsAc,
  getStates as getStatesAc,
  searchMarigrams as searchMarigramsAc,
} from '../../../../../../redux/tsunamis/marigrams/search/marigramSearchActions';
import { Loading } from '../../../../../loadbar/Loading';
import { isDataManager } from '../../../../../../role/roleUtils';
import { withUser } from '../../../../../auth/withUser';
import { MinMaxSearchCard } from '../../../../../form/search/MinMaxSearchCard';
import {
  TextMatchSearchCard,
} from '../../../../../form/search/TextMatchSearchCard';
import { LatLongSearchCard } from '../../../../../form/search/LatLongSearchCard';

const model = marigramSearchModel.get('name');

class MarigramSearchPageUnwrapped extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    document.title = 'NCEI Hazard Marigram Search';
    const {
      clearMarigramSearch,
      getRegions,
      getCountries,
      getLocations,
      history,
      getStates,
      selectedCountry,
    } = this.props;
    clearMarigramSearch();
    getRegions({ history });
    getCountries({ history });
    getLocations({ history });
    if (selectedCountry) {
      getStates({ country: selectedCountry, history });
    }
  }

  componentDidUpdate(prevProps) {
    const {
      change, selectedCountry, selectedState, getStates, history,
    } = this.props;
    const { selectedCountry: prevSelectedCountry } = prevProps;
    if (prevSelectedCountry !== selectedCountry) {
      if (selectedState) {
        change('.state', '');
      }
      if (selectedCountry) {
        getStates({ country: selectedCountry, history });
      }
    }
  }

  handleSubmit(form) {
    const { searchMarigrams, history, authorities } = this.props;
    const queryParameters = toSearchParameters(form, isDataManager(authorities));
    const location = {
      pathname: '/view/hazards/tsunami/marigram-data',
      search: qs.stringify(toSearchParameters(form, isDataManager(authorities)), { skipNulls: true }),
    };
    searchMarigrams({
      queryParameters, formModel: model, history, location, searchRedirect: true,
    });
  }

  render() {
    const {
      resetForm,
      searching,
      fetched,
      regions,
      countries,
      locations,
      states,
      fetchingStates,
      authorities,
    } = this.props;

    if (!fetched || searching) {
      return (<Loading />);
    }

    const regionsJs = regions.toJS().map(x => ({ id: x.id, description: `${(`00${x.id}`).slice(-2)} - ${x.description}` }));
    const dataManager = isDataManager(authorities);

    return (
      <div className="haz-results-container haz-page-container">
        <Card className="haz-page-card">
          <CardBody>
            <CardTitle tag="h1" className="haz-page-card-title">Search Marigrams</CardTitle>
            <p>
              NCEI converts tsunami marigrams from analog (microfiche) to high-resolution digital images. Microfiche were created in the 1970s from deteriorating paper records. The collection includes records from 1854 to 1994.
            </p>
            <p>
              Please cite individual marigrams. For marigrams that do not have a DOI, please cite as:
              <br />
              <b>
                NOAA National Centers for Environmental Information; NCEI: Archival and Discovery of [Event Month Day, Year] Tsunami Event on Marigrams. NOAA National Centers for Environmental Information. [access date]
              </b>
            </p>
            <Form model={model} onSubmit={this.handleSubmit} noValidate>

              <div>
                <Button color="primary" type="submit" className="ml-5">Search</Button>
                <Button color="secondary" className="ml-3" onClick={resetForm}>Clear</Button>
              </div>
              <br />

              { dataManager && (
              <Card>
                <CardBody>
                  <CardTitle tag="h2">Marigram ID</CardTitle>
                  <LabeledText model=".id" label="ID" />
                  <MinMaxSearchCard min=".minId" max=".maxId">ID Range</MinMaxSearchCard>
                </CardBody>
              </Card>
              )}

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Marigram Parameters</CardTitle>
                  <MinMaxSearchCard min=".minYear" max=".maxYear" helpModalId="marYear">Year</MinMaxSearchCard>
                  <MinMaxSearchCard min=".minMonth" max=".maxMonth" helpModalId="month">Month</MinMaxSearchCard>
                  <MinMaxSearchCard min=".minDay" max=".maxDay" helpModalId="day">Day</MinMaxSearchCard>


                  <div className="form-row">

                    <LabeledSelect childOptions={regionsJs} formGroupClassName={['col-lg-4']} parentModel={model} fieldId="regionCode" label="Region" multiselect filterable />
                    <LabeledSelect childOptions={countries.toJS()} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="country" label="Country" filterable readOnly={fetchingStates} helpModalId="marCountry" />
                    <LabeledSelect childOptions={states.toJS()} formGroupClassName={['col-lg-2']} parentModel={model} fieldId="state" label="Area" readOnly={fetchingStates || !states.size} filterable helpModalId="marState" />
                  </div>
                  <TextMatchSearchCard
                    radioGroupModel=".radios.locationSearchType"
                    textModel=".radios.loc"
                    startsWith="locStart"
                    includes="locInclude"
                    matches="locMatch"
                    doesNotMatch="locNot"
                    helpModalId="marLocName"
                  >
                    Marigram Location
                  </TextMatchSearchCard>

                  <div className="form-row">
                    <LabeledSelect childOptions={locations.toJS()} formGroupClassName={['col-lg-12']} parentModel={model} fieldId="location" label="Select Marigram Location" filterable helpModalId="marLocName" />
                  </div>
                  <LatLongSearchCard model={model} />
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Results</CardTitle>
                  <div className="form-row">
                    <LabeledSelect
                      formGroupClassName={['col-md-12']}
                      parentModel={model}
                      fieldId="assocData"
                      label="Return"
                      requiresValue
                      sorted={false}
                      childOptions={[
                        { id: '1', description: 'All records' },
                        { id: '2', description: 'Only records with images online' },
                        { id: '3', description: 'Only records with digital data' },
                      ]}
                    />
                  </div>
                </CardBody>
              </Card>

              <br />
              <div>
                <Button color="primary" type="submit" aria-label="Search Option 2" className="ml-5">Search</Button>
                <Button color="secondary" className="ml-3" aria-label="Clear Option 2" onClick={resetForm}>Clear</Button>
              </div>

            </Form>
          </CardBody>
        </Card>
      </div>
    );
  }
}

MarigramSearchPageUnwrapped.propTypes = {
  searchMarigrams: PropTypes.func.isRequired,
  clearMarigramSearch: PropTypes.func.isRequired,
  getRegions: PropTypes.func.isRequired,
  getCountries: PropTypes.func.isRequired,
  getLocations: PropTypes.func.isRequired,
  getStates: PropTypes.func.isRequired,
  selectedState: PropTypes.string.isRequired,
  selectedCountry: PropTypes.string.isRequired,
  fetched: PropTypes.bool.isRequired,
  fetchingStates: PropTypes.bool.isRequired,
  regions: ImmutablePropTypes.list.isRequired,
  countries: ImmutablePropTypes.list.isRequired,
  locations: ImmutablePropTypes.list.isRequired,
  states: ImmutablePropTypes.list.isRequired,
  resetForm: PropTypes.func.isRequired,
  searching: PropTypes.bool.isRequired,
  change: PropTypes.func.isRequired,
  history: PropTypes.shape({}).isRequired,
  authorities: ImmutablePropTypes.list.isRequired,
};


const mapStateToProps = state => ({
  searching: state.getIn(['marigramSearchPage', 'searching']),
  selectedCountry: state.getIn([model, 'country']),
  selectedState: state.getIn([model, 'state']),
  fetched: [
    state.getIn(['marigramSearchPage', 'fetchedRegions']),
    state.getIn(['marigramSearchPage', 'fetchedLocations']),
    state.getIn(['marigramSearchPage', 'fetchedCountries']),
  ].every(v => v),
  fetchingStates: state.getIn(['marigramSearchPage', 'fetchingStates']),
  regions: state.getIn(['marigramSearchPage', 'regions']),
  countries: state.getIn(['marigramSearchPage', 'countries']),
  locations: state.getIn(['marigramSearchPage', 'locations']),
  states: state.getIn(['marigramSearchPage', 'states']),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  searchMarigrams: searchMarigramsAc,
  clearMarigramSearch: clearMarigramSearchAc,
  getRegions: getRegionsAc,
  getCountries: getCountriesAc,
  getLocations: getLocationsAc,
  getStates: getStatesAc,
  resetForm: () => actions.reset(model),
  resetField: field => actions.setInitial(`model.${field}`),
  change: (field, value) => actions.change(`${model}${field}`, value),
}, dispatch);

export const MarigramSearchPage = withUser(connect(mapStateToProps, mapDispatchToProps)(MarigramSearchPageUnwrapped));
